import { IntlShape } from "react-intl";

export function checkThereDataTheArray(data:any[], intl:IntlShape, column:string){
  const DEFAULT:any = {}

  DEFAULT[column] = intl.formatMessage({id:'NO_DATA'})

  return data.length ? data : [DEFAULT]
}